module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/icons/KP-f8fb962b892b07c4f9f427144e43da0c.svg";